import React from 'react';

import { Link, IconButton, HomeIcon } from '@gogame/components';

const Home = ({ onChange, dimension }) => {
  const handleClickLink = (e) => {
    onChange(e, [{ type: dimension.id, id: '' }]);
  };

  return (
    <Link onClick={handleClickLink}>
      <IconButton
        tooltip={`${dimension.name} Dimension`}
        icon={<HomeIcon />}
        edge={'start'}
      />
    </Link>
  );
};

export default Home;
